import store from "../store";
import { getNormalizeDate } from "./getNormalizeDate";
import { addCommas } from "./commas";
import { calcDays } from "./calcDays";
import moment from "moment";
import { getProtocoInfo } from './getProtocolInfo';

export const setCalcByRegisterBG = async item => {
  // contractTerm: null
  // customer: "АДМИНИСТРАЦИЯ МАРИИНСКОГО МУНИЦИПАЛЬНОГО ОКРУГА"
  // customer_inn: "4213004230"
  // customer_region: "Кемеровская область"
  // deliveryDate: "2022-03-03T00:00:00.000Z"
  // director: "Подгузов Николай Радиевич"
  // egrul: "г.Москва"
  // firm_info: {,…}
  // guaranteeing: 800
  // link: "https://zakupki.gov.ru/epz/order/notice/ea20/view/protocol/protocol-main-info.html?regNumber=0139300032422000006&protocolId=36608948"
  // lowPrice: 69949.02
  // nmck: 80000
  // notificationNumber: "0139300032422000006"
  // ocveds: "53.10"
  // procent: "87.44 %"
  // profit: 2347835
  // registerDate: null
  // revenue: 211067902
  // title: "Поставка государственных знаков почтовой оплаты (маркированные конверты и марки)"
  // winner_inn: "7724490000"
  // winner_name: "АО \"ПОЧТА РОССИИ\""
  // await store.dispatch("CLEAR_PROTOCOL_INFO");

  await store.dispatch("SET_CALC_PARAM", {
    param: "purchase_number",
    value: item.notificationNumber
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "lot",
    value: 1
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "summ",
    value: item.guaranteeing
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "quaranteesVal",
    value: 4
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "date",
    value: moment().format('DD.MM.YYYY')
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "date2",
    value: null
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "days",
    value: null
  });
  const getProtocol = {
    purchase_number: item.notificationNumber,
    lot: 1,
    winner_inn: item.winner_inn,
    winner_name: item.winner_name,
  };
  await store.dispatch("PROTOCOL_INFO_BY_NUMBER", getProtocol);
  await getProtocoInfo();

  // const dd1 = store.getters.calc.date;
  // const dd2 = store.getters.calc.date2;

  // dd1 &&
  //   dd2 &&
  //   (await store.dispatch("SET_CALC_PARAM", {
  //     param: "days",
  //     value: await calcDays(dd1, dd2)
  //   }));

  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "date3",
  //   value: item.date_isp_dog
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "date4",
  //   value: item.date_finish_dogovor
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "date5",
  //   value: item.date_final_protocol
  // });

  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "nmkc",
  //   value: addCommas(item.nmkc)
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "winprice",
  //   value: addCommas(item.price_predlog)
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "purchasesVal",
  //   value: item.purchase
  // });
  //
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "isBS",
  //   value: item.bs
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "isAvans",
  //   value: item.avans
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "isGarFormZak",
  //   value: item.gar_form_zak
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "isPaper",
  //   value: item.original_paper
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "gar_polz_zaksVal",
  //   value: item.gar_polz_zaksVal === null ? undefined : item.gar_polz_zaksVal
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "your_situationsVal",
  //   value: item.situation === null ? undefined : item.situation
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "note",
  //   value: item.note
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "smp",
  //   value: item.smp
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "decrision_of_price",
  //   value: item.decrision_of_price
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "dogovor_subject",
  //   value: item.dogovor_subject
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "client_inn",
  //   value: item.client_inn
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "client_address",
  //   value: item.client_address
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "client_name",
  //   value: item.client_name
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "client_kpp",
  //   value: item.client_kpp
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "client_ogrn",
  //   value: item.client_ogrn
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "customer",
  //   value: item.customer
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "customer_inn",
  //   value: item.customer_inn
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "customer_kpp",
  //   value: item.customer_kpp
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "customer_ogrn",
  //   value: item.customer_ogrn
  // });
  // await store.dispatch("SET_CALC_PARAM", {
  //   param: "customer_adres",
  //   value: item.customer_adres
  // });
};

const setCalc = async item => {
  await store.dispatch("SET_CALC_PARAM", {
    param: "summ",
    value: addCommas(item.summ)
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "trebUvelSumm",
    value: item.trebUvelSumm
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "trebUvelSumm2",
    value: item.trebUvelSumm2
  });

  await store.dispatch("SET_CALC_PARAM", {
    param: "calcSession",
    value: item.session
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "purchase_number",
    value: item.purchase_number
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "lot",
    value: item.lot_number
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "date",
    value: getNormalizeDate(item.date_from, "ru")
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "date2",
    value: getNormalizeDate(item.date_to, "ru")
  });

  const dd1 = store.getters.calc.date;
  const dd2 = store.getters.calc.date2;

  dd1 &&
    dd2 &&
    (await store.dispatch("SET_CALC_PARAM", {
      param: "days",
      value: await calcDays(dd1, dd2)
    }));

  await store.dispatch("SET_CALC_PARAM", {
    param: "date3",
    value: item.date_isp_dog
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "date4",
    value: item.date_finish_dogovor
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "date5",
    value: item.date_final_protocol
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "nmkc",
    value: addCommas(item.nmkc)
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "winprice",
    value: addCommas(item.price_predlog)
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "purchasesVal",
    value: item.purchase
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "quaranteesVal",
    value: item.quarantee
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "isBS",
    value: item.bs
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "isAvans",
    value: item.avans
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "isGarFormZak",
    value: item.gar_form_zak
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "isPaper",
    value: item.original_paper
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "gar_polz_zaksVal",
    value: item.gar_polz_zaksVal === null ? undefined : item.gar_polz_zaksVal
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "your_situationsVal",
    value: item.situation === null ? undefined : item.situation
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "note",
    value: item.note
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "smp",
    value: item.smp
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "decrision_of_price",
    value: item.decrision_of_price
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "dogovor_subject",
    value: item.dogovor_subject
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "client_inn",
    value: item.client_inn
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "client_address",
    value: item.client_address
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "client_name",
    value: item.client_name
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "client_kpp",
    value: item.client_kpp
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "client_ogrn",
    value: item.client_ogrn
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "customer",
    value: item.customer
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "customer_inn",
    value: item.customer_inn
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "customer_kpp",
    value: item.customer_kpp
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "customer_ogrn",
    value: item.customer_ogrn
  });
  await store.dispatch("SET_CALC_PARAM", {
    param: "customer_adres",
    value: item.customer_adres
  });
};

export const sendToCalc = async item => {
  await store.dispatch("GetBanksTags");
  await setCalc(item);
  await store.commit('setCalcRegisterId',item._id)
};

export const sendToCalcResult = async item => {
  await store.dispatch("GetBanksTags");
  const data = await store.dispatch("GET_CALC_REGISTER_BY_ID", item._id);

  await setCalc(data);
  await store.commit('setCalcRegisterId',item._id)
  await store.commit(
    "SET_PODHODIT",
    data.table.map(item => {
      item.rate = Number(parseFloat(item.rate));
      return item;
    })
  );
};
